import { gql } from '@apollo/client';

import { TCashbackRule } from './types';

export const GET_CACHED_CASHBACK = gql`
  query depositCashback {
    id
    amount
    value
    is_percent
    is_active
    starts_at
    expires_at
  }
`;

export interface IGetCashbacksResponse {
  depositCashbacks: Array<TCashbackRule>;
}
export const GET_CASHBACKS = gql`
  query depositCashbacks {
    depositCashbacks {
      id
      amount
      value
      is_percent
      is_active
      starts_at
      expires_at
    }
  }
`;

export interface ICashbackInput {
  amount: number;
  value: number;
  is_percent: boolean;
  is_active: boolean;
  starts_at?: string;
  expires_at?: string;
}

export interface ICreateCashbackRequest {
  input: ICashbackInput;
}
export interface ICreateCashbackResponse {
  createDepositCashback: TCashbackRule;
}
export const CREATE_CASHBACK = gql`
  mutation createDepositCashback($input: DepositCashbackInput!) {
    createDepositCashback(input: $input) {
      id
      amount
      value
      is_percent
      is_active
      starts_at
      expires_at
    }
  }
`;

export interface IUpdateCashbackRequest {
  id: number;
  input: ICashbackInput;
}
export interface IUpdateCashbackResponse {
  updateDepositCashback: TCashbackRule;
}
export const UPDATE_CASHBACK = gql`
  mutation updateDepositCashback($id: Int!, $input: DepositCashbackInput!) {
    updateDepositCashback(id: $id, input: $input) {
      id
      amount
      value
      is_percent
      is_active
      starts_at
      expires_at
    }
  }
`;

export interface IDeleteCashbackRequest {
  id: number;
}
export interface IDeleteCashbackResponse {
  deleteDepositCashback: {
    id: number;
  };
}
export const DELETE_CASHBACK = gql`
  mutation deleteDepositCashback($id: Int!) {
    deleteDepositCashback(id: $id) {
      id
    }
  }
`;
